import { render, staticRenderFns } from "./loadingTab.vue?vue&type=template&id=350a0d30&scoped=true"
import script from "./loadingTab.vue?vue&type=script&lang=js"
export * from "./loadingTab.vue?vue&type=script&lang=js"
import style0 from "./loadingTab.vue?vue&type=style&index=0&id=350a0d30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350a0d30",
  null
  
)

export default component.exports